import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { SelectedDevicesService } from "../../core/services/device-selection.service";
import { Router } from "@angular/router";
import { NoRecordsFoundComponent } from "../../shared/no-records-found/no-records-found.component";
import { NotificationStateService } from "../../core/services/notifications.service";

@Component({
  selector: "app-success-devices",
  standalone: true,
  imports: [CommonModule, NoRecordsFoundComponent],
  templateUrl: "./success-devices.component.html",
  styleUrl: "./success-devices.component.scss",
})
export class SuccessDevicesComponent implements OnInit {
  @Output() receivedModification = new EventEmitter();
  @Input() successDeviceList: any;
  @Input() planName: string = "";
  deviceLoader: boolean = true;
  deviceImages: any = [
    "N881",
    "D241",
    "placeholder",
    "W482",
    "W881",
    "W452",
    "B451",
    "W891",
    "B463",
    "B862",
    "F861",
    "F461",
    "W261",
    "ACCH",
    "SL30",
    "W463"
  ];

  constructor(
    private selectedDevicesService: SelectedDevicesService,
    private router: Router,
    private notificationService: NotificationStateService
  ) {}
  ngOnInit(): void {}

  getImageUrl(deviceModelId: string): string {
    const placeholderPath = "assets/images/placeholder.png";
    if (deviceModelId) {
      const prefix = deviceModelId.substring(0, 4).toUpperCase();
      if (prefix.startsWith("N") || prefix.startsWith("D")) {
        return `assets/images/products/NVRDVR.png`;
      }
      if (prefix.startsWith("L")) {
        return placeholderPath;
      }
      if (
        this.deviceImages.some((imageId: string) =>
          imageId.toUpperCase().startsWith(prefix)
        )
      ) {
        return `assets/images/products/${prefix}.png`;
      }
    }
    return placeholderPath;
  }

  modifyPlan(modifyCheck: boolean) {
    this.receivedModification.emit(modifyCheck);

    this.selectedDevicesService.setModify(modifyCheck);
    this.notificationService.updateModiy(modifyCheck);
  }
}
